import { Box, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { MarkdownView } from 'src/common/components/markdown-editor/MarkdownView';
import { LoadingAnimation } from '../chat/components/LoadingAnimation';
import { camelCaseOrSnakeCaseToWords } from 'src/data-capture/merge-review/ReviewHelperFunctions';
import { ThinkingTile } from './ThinkingTile';

type Props = {
  content: string;
  thinkingContent?: string;
  isThinking?: boolean;
  currentState?: string;
  currentToolName?: string;
  retryNotice?: string;
  dark?: boolean;
};

export function SiestaMessage({
  content,
  thinkingContent,
  isThinking,
  currentState,
  currentToolName,
  retryNotice,
  dark,
}: Props) {
  const statusLabel =
    currentToolName || (currentState && camelCaseOrSnakeCaseToWords(currentState));

  return (
    <Box>
      {retryNotice ? (
        <Flex justify="start" align="center" gap="xs" mb="xs">
          <LoadingAnimation />
          <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="orange.7">
            {retryNotice}
          </Text>
        </Flex>
      ) : (
        isThinking &&
        statusLabel && (
          <>
            <Flex justify="start" align="center" mb="xs">
              <LoadingAnimation />
            </Flex>
            <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="orange.7">
              {currentToolName || `${statusLabel}...`}
            </Text>
          </>
        )
      )}
      {thinkingContent && <ThinkingTile content={thinkingContent} />}
      <Box
        fz="var(--mantine-font-size-textSm)"
        fw={FONT_WEIGHTS.medium}
        c={dark ? 'gray.2' : 'gray.8'}
      >
        <MarkdownView value={content} />
      </Box>
    </Box>
  );
}
